
import { ChatBotConfig } from './types';

export const CHATBOT_CONFIG: ChatBotConfig = {

  // Feature Flags
  enableContextCapture: false,
  enablePageContentCapture: false,

  // Behavior
  persistHistory: true,
  autoOpen: false,
  feedbackMaxLength: 2000,
};

// Message Configuration
export const MESSAGE_CONFIG = {
  maxLength: 200,
  typingDelay: 500,
};

// Session Storage Keys
export const STORAGE_KEYS = {
  messages: 'chatbot_messages',
  isOpen: 'chatbot_is_open',
  sessionReady: 'chatbot_session_ready',
};
